const NavBar = () => {
  return (
    <nav className='h-70 w-90 px-10 py-5 text-white mb-5'>
      <div className='container-mx-auto'>
        <h3 className='mx-auto uppercase bu'>api del clima - <a href="https://openweathermap.org/">openweathermap</a></h3>
      </div>
    </nav>
  )
}

export default NavBar;